module.exports = __webpack_public_path__ + "static/partnership_configuration-96f075ae58fcd40dc1a6f85d5714f00c.png";